import React from 'react'

export default function Header({title, children}) {
  return (
    <header className="text-center">
        <h1 className="text-3xl font-serif font-bold bg-gradient-to-r from-primary to-primaryLight text-white py-3 px-6 mb-4 rounded-lg shadow-md">{title}</h1>
        {children}
    </header>
  )
}
